










































import { Vue, Component, Prop } from 'vue-property-decorator';
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import IntroVideosMolecule from '@/components/molecule.introVideos.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';

import introVideos from '@/mixins/UGC/introVideos';

@Component({
  components: {
    CustomButton,
    CustomContainer,
    CustomModal,
    IntroVideosMolecule,
    ModalHeader,
  },
  mixins: [introVideos],
})
export default class IntroVideos extends Vue {
  @Prop({ default: false })
  autoOpen!: boolean;

  @Prop({ default: false })
  fullScreen!: boolean;

  @Prop({ default: 'customizer' })
  type!: string;

  closeAction() {
    this.$modal.hide('introVideos');
  }
}
